import React from 'react';
import { Box } from '@mui/material';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import { urlManager } from '../../../../../Utils/URL/URLManager';
import { LinkStyled } from '../../../../../Components/Links/BaseLink/BaseLink.styles';

interface Props {}

const SuccessView: React.FC<Props> = () => (
  <Box
    sx={{
      display: 'flex',
    }}
  >
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <TagFacesIcon
        sx={{
          fontSize: '8rem',
          color: 'orange',
        }}
      />
    </Box>
    <Box
      sx={{
        flexGrow: 10,
        textAlign: 'left',
      }}
    >
      <h3>Congratulations!</h3>
      <div>
        Now you can <LinkStyled to={urlManager.signIn()}>to login</LinkStyled>
      </div>
    </Box>
  </Box>
);

export default SuccessView;
